/**
 * Pendant zu `ApiCategorieService.GetMy()`: lädt die Kategorien des Benutzers und spiegelt
 * die darin enthaltenen Views in den Auth-Kontext (im Altclient `_userManager.Views`).
 */

import { useCallback, useEffect, useState } from 'react';

import { categoryApi } from '@/api/services/categoryApi';
import { useAuth } from '@/auth/useAuth';
import type { ChinaAppSysGroupCategory } from '@/types/entities';

export interface MyCategoriesState {
  categories: ChinaAppSysGroupCategory[];
  loading: boolean;
  reload(): Promise<void>;
}

export function useMyCategories(): MyCategoriesState {
  // eslint-disable-next-line @typescript-eslint/unbound-method -- stabile Closure, keine Methode
  const { setViews } = useAuth();
  const [categories, setCategories] = useState<ChinaAppSysGroupCategory[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async (): Promise<void> => {
    setLoading(true);
    try {
      const data = await categoryApi.getMy();
      setCategories(data);
      setViews(data.flatMap((category) => category.Views ?? []));
    } finally {
      setLoading(false);
    }
  }, [setViews]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { categories, loading, reload };
}
